import { EventArgsMap, EventName } from '../types';

import eventEmitter from '../events/EventEmitter';

export { EventName } from '../types';

export function addEventListener<K extends keyof EventArgsMap>(
    eventName: K,
    callback: (event: EventArgsMap[K]) => void,
    options?: boolean | AddEventListenerOptions
): void;
export function addEventListener<T>(
    eventName: EventName,
    callback: (detail?: T) => void
): void {
    eventEmitter.addEventListener(eventName, {
        handleEvent: (evt: CustomEvent) => callback(evt.detail as T),
    });
}

export function removeEventListener<K extends keyof EventArgsMap>(
    eventName: K,
    listener: (event: EventArgsMap[K]) => void,
    options?: boolean | AddEventListenerOptions
): void;
export function removeEventListener(
    type: EventName,
    callback: EventListenerOrEventListenerObject | null,
    options?: EventListenerOptions | boolean
): void {
    eventEmitter.removeEventListener(type, callback, options);
}
